export default "__VITE_ASSET__CaKeViBU__"